import { useBreakpointValue } from '@chakra-ui/react';

import useIsMounted from './useIsMounted';

export default function useIsMobile(ssr = true) {
  const isMounted = useIsMounted();

  return useBreakpointValue({ base: true, lg: false }, { ssr: ssr || !isMounted });
}
